import { Base } from './base';
export class SameValue extends Base {
    constructor(value, valueRepeat, fieldName, errorMsg) {
        super(fieldName, value);
        this.errorMsg = `"${this.getFieldname()}" has not the same value as "${this.getFieldname().replace('Repeat', '')}"`;
        this.valueRepeat = String(valueRepeat);
        if (errorMsg && errorMsg !== '') {
            this.errorMsg = errorMsg;
        }
    }
    isValid() {
        if (this.value !== this.valueRepeat) {
            this.errors.push(this.errorMsg);
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=sameValue.js.map